<template>
    <div class="record-box">
        <img class="img-back" v-if="operation=='record'" @click="back" src="../../assets/image/magSys/back.png" alt="">
        <div v-if="!operation">
            <div class="table-contaniner animate__animated animate__fadeIn">
                <div v-for="(item,index) in cardDataList" :key="index" @click="toRecord(item)" class="card-item">
                    <div class="label-type" :class="filterVersion(item.resType).value">{{ filterVersion(item.resType).label }}</div>
                    <img :src="item.softwareCover?$severUrl(item.softwareCover):$virtual" class="img-item" alt="">
                    <div class="bottom-title">
                        <p class="overflow">{{ item.softwareName }}</p>
                        <div class="statistics-box">
                            <div class="show-item">
                                <el-tooltip class="item" effect="dark" content="实训时长" placement="top-start">
                                    <img src="../../assets/image/software/train_time.png" alt="">
                                </el-tooltip>
                                <p>{{ item.trainingTime||0 }}</p>
                            </div>
                            <div class="show-item">
                                    <el-tooltip class="item" effect="dark" content="实训人次" placement="top-start">
                                        <img style="width: 1.8rem;height: auto;" src="../../assets/image/software/person_num.png" alt="">
                                    </el-tooltip>
                                    <p>{{ item.trainingCount?(item.trainingCount+'次'):(0+'次') }}</p>
                            </div>
                            <div class="show-item">
                                    <el-tooltip class="item" effect="dark" content="完成率" placement="top-start">
                                        <img src="../../assets/image/software/train_rate.png" alt="">
                                    </el-tooltip>
                                    <p>{{ item.finishingRate?(item.finishingRate+'%'):(0+'%') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-box" v-if="cardDataList.length>0">
                <el-pagination
                    background
                    @size-change="changePageSize($event,'card')"
                    @current-change="changeCurrentPage($event,'card')"
                    :current-page="cardPages.current"
                    :page-sizes="[8, 16, 32]"
                    :page-size="cardPages.size"
                    :pager-count="5"
                    :layout="$store.state.media.layout"
                    :total="cardPages.total">
                </el-pagination>
            </div>
            <no-data style="height: calc(100vh - 43rem);" v-if="cardDataList.length==0"></no-data>
        </div>
        <div v-else>
            <train-record-table :classifyCode="classifyCode" ref="train_record_table"></train-record-table>
        </div>
    </div>
</template>

<script>
import {QuerySoftwareDrillList } from '@/api/virtualSoftware';
import { filterVersion } from '@/utils/utils';
import NoData from '../common/NoData.vue';
import TrainRecordTable from './trainRecord/TrainRecordTable.vue';
    export default {
  components: { NoData, TrainRecordTable },
        props:['classifyCode','name'],
        data(){
            return {
                /**软件记录卡片数据 */
                cardDataList:[],
                /**卡片分页器 */
                cardPages:{
                    current:1,
                    size:8,
                    total:1,
                },
                /**操作页面 */
                operation:''
            }
        },
        methods:{
            filterVersion,
            /**返回记录页 */
            back(){
                this.operation='';
                this.$emit('changeOpt',true);
                this.querySoftwareDrillList();
            },
            /**查看实训记录 */
            toRecord(item){
                this.operation='record';
                this.$emit('changeOpt',false);
                this.$nextTick(()=>{
                    let dom=this.$refs.train_record_table;
                    if(dom){
                        dom.softwareCode=item.softwareCode;
                        dom.pageQuerySoftwareDrillList();
                        dom.title=item.softwareName;
                    }
                })
            },
            /**分页查询虚仿实训记录 */
            querySoftwareDrillList(){
                var params={
                "classifyCode": this.classifyCode,
                "current": this.cardPages.current,
                "size": this.cardPages.size,
                "softwareCode": '',
                "softwareName": this.name
                };
                QuerySoftwareDrillList(params).then(res=>{
                    if(res.code==200){
                        this.cardDataList=res.data.records;
                        this.cardPages.total=res.data.total;
                    }
                })
            },
            search(){
                this.cardPages.current=1;
                this.querySoftwareDrillList();
            },
            changeCurrentPage(e){
                this.cardPages.current=e;
                this.querySoftwareDrillList();
            },
            changePageSize(e){
                this.cardPages.size=e;
                this.search();
            },
        },
        mounted(){
            this.querySoftwareDrillList();
        },
        beforeDestroy(){
            this.$emit('changeOpt',true);
        }
    }
</script>

<style lang="less" scoped>
.record-box{
    height: 100%;
    position: relative;
    margin-top: 1.5rem;
}
.img-back{
    position: absolute;
    top: -5rem;
    right: 0;
    cursor: pointer;
    width: 2.2rem;
}
.table-contaniner{
    display: flex;
    flex-wrap: wrap;
    column-gap: 2rem;
    row-gap: 4rem;
    &> :nth-child(n){
        transition: all 0.3s;
    }
}
/deep/.el-dialog__body{
    padding: 0 2rem 3rem 2rem;
    max-height: 80rem;
    overflow: auto;
}
.number{
    cursor: pointer;
    color: var(--blue);
}
.card-item{
    width: calc((100% - 6rem)/4);
    min-width: 28rem;
    border-radius: 0.8rem;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    .label-type{
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 0.8rem 0px 1rem 0px;
        padding: 0.4rem 0.6rem;
    }
    .img-item{
        aspect-ratio: var(--aspectRatio);
        width: 100%;
        object-fit: cover;
    }
    .bottom-title{
        padding: 2rem 1.5rem;
        background-color: #ffffff;
        color: #151c34;
        font-weight: 700;
        font-size: 16px;
    }
}
.page-box{
    padding: 3rem 0;
    display: flex;
    justify-content: center;
}
.card-item:hover{
    transform: translateY(-2rem);
}
.show-item{
    display: flex;
    align-items: center;
    img{
        width: 10px;
        height: auto;
        object-fit: cover;
    }
    &> :nth-child(2){
        color: #334681;
        font-size: 12px;
        margin-left: 1rem;
    }
}
.statistics-box{
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    &> :nth-child(n){
        margin-left: 1.5rem;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
}
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__header{
    font-weight: 700;
    padding: 3rem 5rem;
}
@media screen and (max-width:750px){
    .card-item{
        width: 100% !important;
    }
}
</style>